import { NgModule } from '@angular/core';
import { DxFormGroupDirective } from './form-group.directive';

@NgModule({
  declarations: [DxFormGroupDirective],
  exports: [DxFormGroupDirective],
})
export class FormGroupDirectiveModule {}
